import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import cx from 'classnames';
import filesize from 'filesize';
import _ from 'lodash';
import moment from 'moment';
import React, { useContext } from 'react';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import CircularProgress from '@material-ui/core/CircularProgress';
import fileStyles from '../../file-icons.css'; // eslint-disable-line css-modules/no-unused-class
import SkholeIcon13 from '../../statelessComponents/Icons/SkholeIcon13';
import ContextProvider from '../../../context';
import s from './Attachment.scss';
import messages from './messages';

const Attachment = ({
  item,
  displayConcisely,
  total,
  readOnly,
  intl: { formatMessage },
  uploadingAttachment,
  showConfirmDelete,
  withSocketServerValidation,
  socketServerValidationResult,
}) => {
  const { cloudfrontUrl } = useContext(ContextProvider);

  return (
    <div
      className={cx(s.item, {
        [s.concisely]: displayConcisely,
        [s.items2]: displayConcisely && total <= 2,
        [s.items1]: displayConcisely && total === 1,
      })}
    >
      <div>
        <div className={cx(fileStyles.file, fileStyles[item.type])} />
      </div>
      <div className={s.info}>
        <Button
          component="a"
          href={`${cloudfrontUrl}/${item.path}`}
          target="_blank"
          className={cx(s.button, s.fileNameBtn)}
        >
          <Typography variant="h5" className={s.fileName}>
            {item.name}
          </Typography>
        </Button>
        <div className={s.details}>
          <div>
            <Typography variant="body1" className={s.attrTitle}>
              <FormattedMessage {...messages.type} />
            </Typography>{' '}
            {_.toUpper(item.type)}
          </div>
          <div>
            <Typography variant="body1" className={s.attrTitle}>
              <FormattedMessage {...messages.size} />
            </Typography>{' '}
            {filesize(item.size)}
          </div>
          {!displayConcisely ||
            (total === 1 && (
              <div>
                <Typography variant="body1" className={s.attrTitle}>
                  <FormattedMessage {...messages.uploaded} />
                </Typography>{' '}
                {moment(item.uploadedDate).format('DD/MM/YYYY HH:mm')}
              </div>
            ))}
        </div>
      </div>
      {!displayConcisely && !readOnly && (
        <div className={s.btn}>
          <Tooltip title={formatMessage(messages.deleteAttachmentTitle)}>
            <IconButton
              onClick={showConfirmDelete}
              className={cx(s.button, s.notDisplayOnMobile)}
              disabled={
                !!uploadingAttachment ||
                readOnly ||
                (withSocketServerValidation && !socketServerValidationResult)
              }
            >
              <SkholeIcon13 className={s.removeIcon} />
            </IconButton>
          </Tooltip>
          <Button
            onClick={showConfirmDelete}
            className={cx(s.button, s.notDisplayOnTabletAndDesktop)}
            disabled={
              !!uploadingAttachment ||
              readOnly ||
              (withSocketServerValidation && !socketServerValidationResult)
            }
            fullWidth
            variant="outlined"
            size="large"
            color="primary"
          >
            <div className={s.removeIcon} />
            &nbsp;
            <FormattedMessage {...messages.deleteAttachmentTitle} />
          </Button>
        </div>
      )}
      {withSocketServerValidation && (
        <div>
          {!socketServerValidationResult && (
            <div className={s.validatingBlock}>
              <FormattedMessage {...messages.socketServerValidating} />
              <CircularProgress size={20} />
            </div>
          )}
          {!!socketServerValidationResult &&
            !socketServerValidationResult?.isValid && (
              <Typography color="error">
                {socketServerValidationResult.error}
              </Typography>
            )}
        </div>
      )}
    </div>
  );
};

Attachment.propTypes = {
  readOnly: PropTypes.bool,
  showConfirmDelete: PropTypes.func,
  total: PropTypes.number.isRequired,
  item: PropTypes.shape({
    type: PropTypes.string,
    path: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.oneOf(PropTypes.string, PropTypes.number),
    uploadedDate: PropTypes.oneOf(PropTypes.string, PropTypes.instanceOf(Date)),
  }).isRequired,
  displayConcisely: PropTypes.bool,
  uploadingAttachment: PropTypes.number,
  intl: intlShape.isRequired,
  socketServerValidationResult: PropTypes.shape({
    path: PropTypes.string,
    error: PropTypes.string,
    isValid: PropTypes.bool,
  }),
  withSocketServerValidation: PropTypes.bool,
};

Attachment.defaultProps = {
  readOnly: false,
  displayConcisely: false,
  uploadingAttachment: 0,
  showConfirmDelete: () => null,
  socketServerValidationResult: null,
  withSocketServerValidation: false,
};

export default compose(
  injectIntl,
  withStyles(s),
  withStyles(fileStyles),
)(Attachment);
